<template>
    <section class="fst-LLMNotions admin-content">
        <div class="filter">
            <el-select v-model="sC"
                       style="width: 405px"
                       @change="handleSelectConfig"
                       value-key="id"
                       popper-class="templateSelect"
                       placeholder="Выберите конфигурацию">
                <el-option v-for="(tpl, key) in llmNotionConfigs"
                           :label="tpl.name"
                           :value="tpl"
                           :key="key">
                    <div class="title">{{tpl.name}}</div>
                    <div class="desc" v-if="tpl.description"
                         v-html="tpl.description"></div>
                </el-option>
            </el-select>
            <!--el-button type="primary" @click="handleSaveConfig">
                <i class="fal fa-save mr-1"></i>
                Сохранить
            </el-button-->
            <el-button type="success" title="Новая конфигурация" plain class="ml-0"
                       @click="handleResetConfig">
                <i class="fas fa-plus"></i>
            </el-button>
        </div>

        <!-----------------------  || FILTER || ----------------------------->

        <div v-loading.fullscreen.lock="loading" data-role="result">
            <el-input v-model="sC.name" placeholder="Название конфигурации"
                      style="width: 600px"
                      class="mb-2" clearable></el-input>
            <!--el-input v-model="sC.description" placeholder="Описание"
                      style="width: 600px" type="textarea" rows="3"
                      class="mb-3" clearable></el-input-->

            <!---------------  = PARAMS = --------------->
            <el-collapse class="params" v-model="visibleSections">
                <el-collapse-item title="Подбор понятий" :name="0">
                    <llm-block :llm="sC.generateConceptsTemplate"
                               title="Настройки LLM для поиска понятий по теме"></llm-block>
                </el-collapse-item>
                <el-collapse-item title="Создание понятий" :name="1">
                    <llm-block :llm="sC.generateTermsTemplate"
                               v-show="false"
                               title="Настройки LLM для подбора терминов понятия"></llm-block>
                    <llm-block :llm="sC.generateQueryTemplate"
                               title="Настройки LLM для генерации поискового запроса понятия"></llm-block>
                    <!--h3>Требования к запросу (шаблону)</h3-->
                    <el-input v-model="sC.queryRequirementsBoilerplate"
                              v-show="false"
                              :rows="5"
                              type="textarea"></el-input>
                </el-collapse-item>

                <el-collapse-item title="Анализ  понятий" :name="2">
<!--
                    <llm-block :llm="sC.analyzeQueryTemplate"
                               title="Настройки LLM для анализа понятий"></llm-block>
-->
                    <llm-block :llm="sC.classifyDocumentTemplate"
                               title="Настройки LLM для сравнения документа с запросом"></llm-block>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="footer">
            <el-button type="primary" @click="handleSaveConfig">
                <i class="fal fa-save mr-1"></i>
                Сохранить
            </el-button>
            <el-button v-if="sC.id" type="danger" title="Удалить шаблон" plain class="ml-0"
                       @click="handleDelConfig">
                <i class="fal fa-trash-alt mr-1"></i>
                Удалить
            </el-button>
            <el-button v-if="sC.id" type="primary" title="Новый шаблон" plain class="ml-0" @click="handleResetConfig">
                <i class="fal fa-times mr-1"></i>
                Очистить
            </el-button>

        </div>
    </section>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import LlmBlock from "./llm/views/LlmBlock";
    import Mixins from "../../components/common/mixin";

    const llmDefault = {
            id: null,
            "alias": "",
            "name": "",
            "description": "",
            "script": "",
            "contextSize": 0,
            "templates": [
                null
            ]
        },
        configDefault = {
            id: null,
            "name": "",
            "generateConceptsTemplate": {
                id: null,
                llm: {
                    id: null,
                    name: ''
                }

            },
            "generateTermsTemplate": {
                id: null,
                llm: {
                    id: null,
                    name: ''
                }
            },
            "generateQueryTemplate": {
                id: null,
                llm: {
                    id: null,
                    name: ''
                }
            },
            "queryRequirementsBoilerplate": '',
            "analyzeQueryTemplate": {
                id: null,
                llm: {
                    id: null,
                    name: ''
                }
            },
            "classifyDocumentTemplate": {
                id: null,
                llm: {
                    id: null,
                    name: ''
                }
            },

        };

    export default {
        name: "LLMNotions",
        components: {LlmBlock},
        mixins: [Mixins],
        computed: {
            ...mapState({
                llmList: state => state.llm.list,
                llmNotionConfigs: state => state.llm.llmNotionConfigs,
            }),
        },
        data() {
            return {
                loading: true,
                visibleSections: [0, 1, 2],
                sC: _.cloneDeep(configDefault),
                llmDefault: _.cloneDeep(llmDefault),
                configDefault: _.cloneDeep(configDefault),

            }
        },
        mounted() {
            Promise.all([this.getLlms({prepare: {target: this.$el}}), this.getLlmNotionConfigs({prepare: {target: this.$el}})]).then(() => {
                // console.log('llms:::', this.llmList)
                // console.log('llmConfs::', this.llmNotionConfigs)
                // this.sC = this.llmNotionConfigs[0] || {}
                this.sC = _.cloneDeep(configDefault)
                this.loading = false;
            })
        },
        methods: {
            ...mapActions('llm', ['getLlms', 'getLlmNotionConfigs', 'saveConfig', 'deleteConfig']),
            handleSelectConfig() {
                console.log('--- sC --- ', this.sC);
            },
            handleSaveConfig() {
                let query = _.cloneDeep(this.sC),
                    fieldsToSave = ["generateConceptsTemplate",
                        // "generateTermsTemplate",
                        "generateQueryTemplate",
                        "classifyDocumentTemplate"];
                fieldsToSave.forEach(field => {
                    query[field] = _.pickBy(query[field], (data, key) => key === 'id')
                })
                query.name = query.name || ("Конфигурация #" + (this.llmNotionConfigs.length + 1))
                console.log('__query__', query);
                let validated = _.filter(query, (field, key) => fieldsToSave.includes(key) && field.id).length; //&& query.queryRequirementsBoilerplate;
                if (validated) {
                    this.loading = true;
                    this.saveConfig(query).then(data => {
                        this.sC = data;
                        setTimeout(() => {
                            this.loading = false;
                        }, 400)
                    }, err => {
                        this.handleError(err);
                    })
                } else {
                    this.$alert('Заполнены не все поля. Сохранение не возможно.', 'Внимание', {
                        confirmButtonText: 'OK',
                        type: 'error'
                    })
                }
            },
            handleResetConfig() {
                this.sC = _.cloneDeep(configDefault)
            },
            handleDelConfig() {
                this.$confirm('Удалить данную конфигурацию?', 'Внимание', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.deleteConfig(this.sC.id).then(() => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.handleResetConfig();
                        setTimeout(() => {
                            this.loading = false;
                        }, 400)
                    }, err => {
                        this.handleError(err);
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss">
    .fst-LLMNotions {
        .filter {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 15px;
        }

        .el-textarea {
            width: 790px;
        }

        h3 {
            margin: 15px 0 5px;

            &:first-child {
                margin-top: 0;
            }
        }

        .llmBlock + .llmBlock {
            margin-top: 15px;
        }

        .footer {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 12px;
            margin-top: 15px;
        }
    }
</style>